import 'lazysizes/plugins/blur-up/ls.blur-up';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes';
import 'jquery-lazyload-any';

export default () => {
    $.hook('x-lazyload-element').lazyload({
        // Sets the pixels to load earlier. Setting threshold to 200 causes image to load 200 pixels
        // before it appears on viewport. It should be greater or equal zero.
        threshold: 200,

        // Sets the callback function when the load event is firing.
        // element: The content in lazyload tag will be returned as a jQuery object.
        load(element) {
            element.addClass('x-lazyload-element__loaded');
        },

        // Sets events to trigger lazyload. Default is customized event `appear`, it will trigger when
        // element appear in screen. You could set other events including each one separated by a space.
        trigger: 'appear',
    });
};
